import { of, throwError } from 'rxjs'
import { FirstHalf, FirstHalf2, FinalTime } from './MatchEventsDump'
import VoltError from 'VoltError'

/**
 * Ordering of Dump file
 */
const _EVENT_CAPTURE_ORDERING = {
    0: undefined, // Indicate that the match did not start and should thrown an error
    1: FirstHalf,
    2: FirstHalf2,
    4: FinalTime,
}

/**
 * Internal constants: Maximum DUMP
 */
const _MAX_EVENT_DUMP = Object.keys(_EVENT_CAPTURE_ORDERING).length

/**
 * Renew the exercise per GAME
 */
let _CACHE_EVENT_PER_GAME = {}

const addEventToCache = (gameId, event) =>
    (_CACHE_EVENT_PER_GAME = {
        ..._CACHE_EVENT_PER_GAME,
        [gameId]: event,
    })

const getNextEvent = (lastEvent) => {
    if (lastEvent === undefined) return 0
    if (lastEvent >= _MAX_EVENT_DUMP) return _MAX_EVENT_DUMP
    return lastEvent + 1
}

export const fetchLiveSimulator_MatchEvents = (gameId) => {
    const lastEvent = _CACHE_EVENT_PER_GAME[gameId]
    const nextEvent = getNextEvent(lastEvent)
    const result = _EVENT_CAPTURE_ORDERING[nextEvent]
    if (!result) {
        addEventToCache(gameId, nextEvent)
        return throwError(new VoltError(VoltError.codes.OPTA_FEED_NO_DATA))
    }
    addEventToCache(gameId, nextEvent)
    return of({ response: result })
}
